/*
 * File: login.vue.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:54:06
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { IQuery, IQueryDefault } from "@root/core";
import { BaseComponent } from "@root/components";

import { kRememberMe } from "@root/core/private/plugins/authentication";

/// refined at 2023/12/13
@Component
export default class Login extends BaseComponent {
    username: string | null = "";
    password: string | null = "";
    showPassword: boolean = false;
    rememberMe: boolean = false;
    activeTab: "local" | "ldap" = "local";

    query: IQuery = IQueryDefault();

    get usernamePlaceholder(): string {
        return this.activeTab === "ldap"
            ? this.$_("w_LoginLdapPlaceholder")
            : this.$_("w_LoginUsernamePlaceholder");
    }

    get passwordPlaceholder(): string {
        return this.activeTab === "ldap"
            ? this.$_("w_LoginLdapPasswordPlaceholder")
            : this.$_("w_LoginPasswordPlaceholder");
    }

    private async mounted() {
        const accessToken = this.getQuery("accessToken");
        if (accessToken) {
            this.rememberMe = localStorage.getItem(kRememberMe) === "true";
            await this.loginByOAuthToken(accessToken);
            return;
        }

        this.rememberMe = localStorage.getItem(kRememberMe) === "true";
    }

    loginGoogle() {
        const url = this.$server.Url("auth/google" as any).replace(/\?$/, "");
        const realm = "admin";
        localStorage.setItem(kRememberMe, this.rememberMe ? "true" : "false");
        window.location.href = `${url}?realm=${encodeURIComponent(realm)}`;
    }

    private async loginByOAuthToken(accessToken: string) {
        try {
            await this.$login(
                {
                    accessToken,
                    rememberMe: this.rememberMe,
                } as any,
                this.query,
            );
            this.$home();
        } catch (error) {
            if ((error as any)?.handled) return;
            this.$alert?.(
                {
                    title: this.$_("w_Error"),
                    message: this.$_("w_LoginFailed"),
                },
                "danger",
            );
            (error as any).handled = true;
        }
    }

    private getQuery(key: string): string | null {
        const value = this.$route?.query?.[key];
        if (Array.isArray(value)) return value[0] ?? null;
        return typeof value === "string" ? value : null;
    }

    async login() {
        try {
            await this.$login(
                {
                    username: this.username as any,
                    password: this.password as any,
                    "mode": "local",
                    rememberMe: this.rememberMe,
                } as any,
                this.query,
            );

            /// redirect
            this.$home();
        } catch (error) {
            if ((error as any)?.handled) return;
            this.$alert?.(
                {
                    title: this.$_("w_Error"),
                    message: this.$_("w_LoginFailed"),
                },
                "danger",
            );
            (error as any).handled = true;
        }
    }
}
